import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Header";
import Footer from "./components/Footer/Footer";
import Impact from "./pages/Impact";
import ImpactDetail from "./pages/ImpactDetail";
import Donations from "./pages/Donations";
import HowItWorksPage from "./pages/HowItWorksPage";
// import Programs from "./pages/Programs";
// import Conservation from "./pages/Conservation";
import Ourvalues from "./pages/Ourvalues";
// import Updates from "./pages/Updates";
import FAQ from "./pages/FAQ";
import DonationSuccess from "./pages/DonationSuccess";
import Unsubscribe from "./pages/Unsubscribe";
import ContactForm from "./pages/ContactForm";
import LandingPage from "./pages/LandingPage";
import Aboutpage from "./pages/AboutPage";
import AdminRoutes from "./routes/AdminRoutes";

function App() {
  return (
    <Router>
      <Routes>

        {/* Admin routes - no navbar/footer */}
        <Route path="/admin/*" element={<AdminRoutes />} />
        
        <Route
          path="*"
          element={
            <>
              <Navbar />
              <Routes>
                <Route index element={<LandingPage />} />
                <Route path="/about" element={<Aboutpage />} />
                <Route path="/impact" element={<Impact />} />
                <Route path="/impact/:id" element={<ImpactDetail />} />
                <Route path="/donate" element={<Donations />} />
                <Route path="/how-it-works" element={<HowItWorksPage />} />
                {/* <Route path="/our-values" element={<Ourvalues />} /> */}
                <Route path="/faq" element={<FAQ />} />
                <Route path="/donation-success" element={<DonationSuccess />} />
                <Route path="/unsubscribe" element={<Unsubscribe />} />
                <Route path="/contact-us" element={<ContactForm />} />
                {/* <Route path="/programs" element={<Programs />} />
                <Route path="/conservation" element={<Conservation />} />
                <Route path="/updates" element={<Updates />} /> */}
              </Routes>
              <Footer />
            </>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
